import { render, staticRenderFns } from "./booking-confirmation.vue?vue&type=template&id=4f2245df&scoped=true"
import script from "./booking-confirmation.vue?vue&type=script&lang=js"
export * from "./booking-confirmation.vue?vue&type=script&lang=js"
import style0 from "./booking-confirmation.vue?vue&type=style&index=0&id=4f2245df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2245df",
  null
  
)

export default component.exports